var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 bg-dark min-vh-100",attrs:{"id":"app"}},[_c('router-view',{staticClass:"bg-dark"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }